import React, {Component} from 'react';
import {getEnv} from "../../env";
import {connect} from 'react-redux';
import './style.css';

class PromoPhotos extends Component {
	render() {
		const promos = this.props.images.filter(i => i.type === "promo");
		return (
			<div className={"con-promophotos margin-right-15px"}>
				{promos && promos.length > 0 &&
				<img alt="promo" src={getEnv('S3_ASSETS_BUCKET') + '/' + promos[0].path}/>
				}
			</div>
		)
	}
}

const mapStateToProps = (store) => {
	return {
		images: store.adminImages.images,
	};
};

export default connect(mapStateToProps)(PromoPhotos);


// WEBPACK FOOTER //
// ./src/04-containers/PromoPhotos/index.js